var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 57H179.043C177.363 57 176 58.9383 176 61.3293V123.671C176 126.062 177.363 128 179.043 128H232V123.671V61.3293V57Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.304 57H101.696C99.6546 57 98 58.9383 98 61.3293V123.671C98 126.062 99.6546 128 101.696 128H162.304C164.345 128 166 126.062 166 123.671V61.3293C166 58.9383 164.345 57 162.304 57Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3044 57H23.6957C21.6546 57 20 58.9383 20 61.3293V123.671C20 126.062 21.6546 128 23.6957 128H84.3044C86.3454 128 88 126.062 88 123.671V61.3293C88 58.9383 86.3454 57 84.3044 57Z",
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.207 38H20.9102C20.4075 38 20 38.406 20 38.9067C20 39.4075 20.4075 39.8135 20.9102 39.8135H119.207C119.71 39.8135 120.117 39.4075 120.117 38.9067C120.117 38.406 119.71 38 119.207 38Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.091 135H71.9091C71.407 135 71 135.448 71 136C71 136.552 71.407 137 71.9091 137H170.091C170.593 137 171 136.552 171 136C171 135.448 170.593 135 170.091 135Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4007 135H72C71.5 135 71 135 71 136C71 137 71.5 137 72 137H87.5C88 137 88 137 88 136C88 135 88 135 87.4007 135Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.136 41H20.8636C20.3867 41 20 41.4477 20 42C20 42.5523 20.3867 43 20.8636 43H114.136C114.613 43 115 42.5523 115 42C115 41.4477 114.613 41 114.136 41Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2 44H20.8C20.3582 44 20 44.4477 20 45C20 45.5523 20.3582 46 20.8 46H107.2C107.642 46 108 45.5523 108 45C108 44.4477 107.642 44 107.2 44Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8125 47H20.9102C20.4075 47 20 47.406 20 47.9067C20 48.4075 20.4075 48.8135 20.9102 48.8135H92.8125C93.3152 48.8135 93.7227 48.4075 93.7227 47.9067C93.7227 47.406 93.3152 47 92.8125 47Z",
    fill: "#3C4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.223 30H22.7623C20.1005 30 20 31.1193 20 32.5C20 33.8807 20.1005 35 22.7623 35H115.223C117.885 35 118 33.8807 118 32.5C118 31.1193 117.885 30 115.223 30Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4415 23H21.5503C20.0564 23 20 24.1193 20 25.5C20 26.8807 20.0564 28 21.5503 28H73.4415C74.9354 28 75 26.8807 75 25.5C75 24.1193 74.9354 23 73.4415 23Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 175,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.f553f68390f8346b0efa45998f396a20.svg";
export { ForwardRef as ReactComponent };